import React, { useEffect, useState } from 'react'
import userService from '../../services/userService'
import { Permission, Profile, RootCategory } from '../../services/models'
import { Checkbox, Form, message } from 'antd'

type Props = {
    profile: Profile
    permissions: Permission[]
}

const SubscriptionForm: React.FC<Props> = ({ profile, permissions }) => {
  const [form] = Form.useForm()
  const [categories, setCategories] = useState<RootCategory[] | null>(null)
  const [permissionMap, setPermissionMap] = useState<Map<number, boolean>>(new Map<number, boolean>())

  const fetchData = () => {
    userService.getCategories().then(data => setCategories(data.tree))
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    const newMap = new Map<number, boolean>()
    const subscribedServiceIds: number[] = []
    permissions.forEach(p => {
      newMap.set(p.serviceId, p.isSubscribed)
      if (p.isSubscribed) {
        subscribedServiceIds.push(p.serviceId)
      }
    })
    setPermissionMap(newMap)

    form.setFieldValue('subscribedServiceIds', subscribedServiceIds)
  }, [permissions, profile])

  if (!categories) {
    return <></>
  }

  const onSubmitForm = (data: { subscribedServiceIds: number[] }) => {
    console.log('onSubmitForm', { data })
  }

  const onChangeSubscribe = (serviceId: number, checked: boolean) => {
    if (checked) {
      userService.subscribe(serviceId).then(() => {
        message.success('success')
      }).catch(() => {
        message.error('error')
      })
    } else {
      userService.unsubscribe(serviceId).then(() => {
        message.success('success')
      }).catch(() => {
        message.error('error')
      })
    }
  }

  return (
        <div>
            <Form layout="vertical"
                form={form}
                onFinish={onSubmitForm}
            >
                {/* Подпись не «Доступные сервисы»: чекбокс не даёт доступа и не управляет
                    письмами — доступ выдаётся отдельно, а рассылка идёт всем,
                    у кого он есть. Здесь он включает только уведомления в ленте. */}
                <Form.Item name="subscribedServiceIds" label="Уведомления о новых исследованиях в ленте">
                    <Checkbox.Group>
                        <ul>
                            {categories.map(c => (
                                <li key={`c-${c.id}`}>
                                    {c.name}
                                    <ul>
                                        {c.children.map(cc => (
                                            <li key={`cc-${cc.id}`}>
                                                {cc.name}
                                                <ul>
                                                    {cc.services.map(s => (
                                                        <li key={`s-${s.id}`}>
                                                            <Checkbox onChange={(e) => onChangeSubscribe(e.target.value, e.target.checked)} value={s.id} disabled={!permissionMap.has(s.id)}>{s.name}</Checkbox>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </Checkbox.Group>
                </Form.Item>
            </Form>
        </div>
  )
}

export default SubscriptionForm
